import {PayloadAction, createSlice} from "@reduxjs/toolkit"

export const Error404Slice: any = createSlice({
    name: "error404",
    initialState: {enable404: false, error_loading: null} as {
        enable404: boolean
        error_loading: null | boolean
    },
    reducers: {
        setError404Loading: (state, {payload: {error_loading}}: PayloadAction<{error_loading: boolean}>) => {
            state.error_loading = error_loading
        },
        setError404Func: (state, {payload: {enable404}}: PayloadAction<{enable404: boolean}>) => {
            state.error_loading = true
            state.enable404 = enable404
        },
    },
})

export const {setError404Loading, setError404Func} = Error404Slice.actions

export default Error404Slice.reducer
